module.exports = __webpack_public_path__ + "images/help_v2/icon-ppt@2x-1fc3951d1ed0e183df7b11f1a6ae38cb.png";